import { toggleContentOverlay } from "./helper";

// --------------- Submenus ---------------
const navItems = document.querySelectorAll(
    `.main-nav__item[data-menu-level="0"]`
);

const contentOverlay = document.querySelector("#content-overlay");

navItems?.forEach((item) => {
    const itemLink = item.querySelector(".main-nav__link");
    const submenuContainer = item.querySelector(".main-nav__submenu");

    // on hover
    itemLink?.addEventListener("mouseenter", () => {
        hideAllSubmenus(); // Hide all other submenus first
        if (submenuContainer) {
            toggleContentOverlay(true); // Show content overlay
            showSubmenu(submenuContainer);
        }
    });

    // on focus
    itemLink?.addEventListener("focus", () => {
        hideAllSubmenus(); // Hide all other submenus first
        if (submenuContainer) {
            toggleContentOverlay(true); // Show content overlay
            showSubmenu(submenuContainer);
        }
    });

    // on mouseleave (hover end)
    submenuContainer?.addEventListener("mouseleave", () => {
        hideSubmenu(submenuContainer);
    });

    // on blur (focus end)
    submenuContainer?.addEventListener("blur", () => {
        hideSubmenu(submenuContainer);
    });
});

// Hide all submenus when clicking on the content overlay
contentOverlay?.addEventListener("click", () => {
    if (document.body.classList.contains("main-nav-submenu-toggled")) {
        // Fire action only if a submenu is toggled (can be check by looking for a classname in the body's classlist).
        // The content overlay could also be used for other elements like modals.
        hideAllSubmenus();
    }
}
);

document?.addEventListener("DOMContentLoaded", () =>
    toggleContentOverlay(false)
);

/**
 * Helper function to show the submenu of a menu item.
 * @param {Element} submenuContainer Submenu Container
 * @returns
 */
function showSubmenu(submenuContainer) {
    if (!submenuContainer) return; // Fallback

    // Show submenu by JS only on tablets and desktops
    if (typeof window !== "undefined" && window.innerWidth >= 1000) {
        // Add classname to body for other CSS settings
        document.body.classList.add("main-nav-submenu-toggled");
        // Toggle submenu
        submenuContainer.style.maxHeight = `${submenuContainer.scrollHeight}px`;
        submenuContainer.setAttribute("aria-hidden", "false");
    }
}

/**
 * Helper function to hide the submenu of a menu item.
 * @param {Element} submenuContainer Submenu Container
 * @returns
 */
function hideSubmenu(submenuContainer) {
    if (!submenuContainer) return; // Fallback

    // Show submenu by JS only on tablets and desktops
    if (typeof window !== "undefined" && window.innerWidth >= 1000) {
        // Remove classname to body for other CSS settings
        document.body.classList.remove("main-nav-submenu-toggled");
        // Toggle submenu
        toggleContentOverlay(false); // Hide content overlay
        submenuContainer.style.maxHeight = 0;
        submenuContainer.setAttribute("aria-hidden", "true");
    }
}

/**
 * Helper function that loops through all menu items hides their submenus.
 */
function hideAllSubmenus() {
    navItems?.forEach((item) => {
        const submenuContainer = item.querySelector(".main-nav__submenu");
        if (submenuContainer) hideSubmenu(submenuContainer);
    });
}

// --------------- Main Nav Toggle ---------------
const body = document.body;

const mainNavContainer = document.querySelector("#main-nav-container");
const navInnerContainer = document.querySelector(".header__main-nav__inner");

const toggleBtn = document.querySelector("#main-nav-toggle");
const toggleBtnSrText = toggleBtn.querySelector("#header__main-nav-toggle__text");
const toggledClassName = "main-nav-toggled";


toggleBtn?.addEventListener("click", (e) => {
    // Check if main nav is currently toggled by checking `<body />` for specifi class name
    const mainNavToggled = document.body.classList.contains(toggledClassName);

    if (mainNavToggled) {
        // Close nav
        document.body.classList.remove(toggledClassName);
        document.body.classList.remove("overflow-hidden"); // hide overflow of body to prevent scrolling
        toggleBtn.classList.remove("is-active");
        // toggleBtn.setAttribute("title", "Hauptnavigation einblenden");
        // if (toggleBtnSrText) toggleBtnSrText.innerHTML = "Hauptnavigation einblenden";
        if (mainNavContainer) mainNavContainer.style.maxHeight = 0;
        // Remove focus from event target
        e.target.blur();
        // Hide overflow of inner container for duration of transiton to prevent visible scroll bar
        if (navInnerContainer) {
            navInnerContainer.classList.add("overflow-hidden");
            window.setTimeout(() => {
                navInnerContainer.classList.remove("overflow-hidden");
            }, 300);
        }
    } else {
        // Open nav
        document.body.classList.add(toggledClassName);
        document.body.classList.add("overflow-hidden"); // show overflow of body to enable scrolling
        toggleBtn.classList.add("is-active");
        // toggleBtn.setAttribute("title", "Hauptnavigation ausblenden");
        // if (toggleBtnSrText) toggleBtnSrText.innerHTML = "Hauptnavigation ausblenden";
        if (mainNavContainer) mainNavContainer.style.maxHeight = `100%`;
        // Hide overflow of inner container for duration of transiton to prevent visible scroll bar
        if (navInnerContainer) {
            navInnerContainer.classList.add("overflow-hidden");
            window.setTimeout(() => {
                navInnerContainer.classList.remove("overflow-hidden");
            }, 300);
        }
    }

});
